var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCreditcardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#3C3E52",
    opacity: 0.712,
    transform: "translate(-1217 -619) translate(1217 619)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0L26 0 26 26 0 26z",
    transform: "translate(-1217 -619) translate(1217 619) translate(7 7)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#17A141",
    d: "M21.667 4.333H4.333c-1.202 0-2.155.965-2.155 2.167l-.011 13c0 1.203.964 2.167 2.166 2.167h17.334c1.202 0 2.166-.965 2.166-2.167v-13c0-1.202-.964-2.167-2.166-2.167zm0 15.167H4.333V13h17.334v6.5zm0-10.833H4.333V6.5h17.334v2.167z",
    transform: "translate(-1217 -619) translate(1217 619) translate(7 7)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditcardIcon);
export default __webpack_public_path__ + "static/media/creditcard-icon.3c191661.svg";
export { ForwardRef as ReactComponent };